export default function Appearance() {
  return (
    <section className="pxos-card p-6 max-w-xl" data-testid="appearance-section">
      <h2 className="font-display text-xl font-semibold">Aspetto</h2>
      <p className="mt-2 text-sm opacity-70">
        Le opzioni di personalizzazione (tema chiaro/scuro, colori accenti, densità)
        arriveranno nelle prossime fasi. Per ora l'aspetto è ottimizzato per l'utilizzo
        quotidiano su desktop e iPhone Safari.
      </p>
      <div className="mt-4 grid grid-cols-3 gap-3">
        {["#E8A5B7","#B7D4C7","#D4C4A0","#C4A9D4","#A9C8F1","#D4B7A9","#B8B8B8","#F1D4A9"].map((c) => (
          <div key={c} className="rounded-xl p-4 text-xs text-center" style={{ background: c, color: "#4A6078" }}>
            {c}
          </div>
        ))}
      </div>
    </section>
  );
}
